import * as React from 'react';
import { useMiaSelector } from '../../components/hooks';

interface IPermissionOverrideUserTextProps {}

export const PermissionOverrideUserText = React.memo<IPermissionOverrideUserTextProps>(({}) => {
  const user = useMiaSelector(state => state.auth.itOverrideUser);

  return user ? <>Impersonating: {user.name}</> : null;
});
